import {
  ClaimQueryParamsState,
  ClaimQueryStateActions,
  ClaimQueryStateActionType,
} from "./types";

export const claimInitialState: ClaimQueryParamsState = {
  sort_by: "case_id",
  direction: "desc",
  search_query: "",
  page: 1,
  pagination: true,
  start_date: "",
  end_date: "",
  case_id: "",
  patient_name: "",
  claim_status: "",
  file_required: false,
};

export const ClaimQueryParamReducer = (
  state: ClaimQueryParamsState,
  action: ClaimQueryStateActionType
): ClaimQueryParamsState => {
  switch (action.type) {
    case ClaimQueryStateActions.CHANGE_SORT_PARAMS:
      return {
        ...state,
        sort_by: action.payload.sort_by,
        direction: action.payload.direction,
      };

    case ClaimQueryStateActions.CHANGE_SEARCH_QUERY:
      return {
        ...state,
        search_query: action.payload,
      };
       case ClaimQueryStateActions.CHANGE_CASE_ID:
      return {
        ...state,
        case_id: action.payload,
      };
       case ClaimQueryStateActions.CHANGE_PATIENT_NAME:
      return {
        ...state,
        patient_name: action.payload,
      };
       case ClaimQueryStateActions.CHANGE_CLAIM_STATUS:
      return {
        ...state,
        claim_status: action.payload,
      };

    case ClaimQueryStateActions.CHANGE_START_DATE:
      return {
        ...state,
        start_date: action.payload,
      };

    case ClaimQueryStateActions.CHANGE_END_DATE:
      return {
        ...state,
        end_date: action.payload,
      };

    case ClaimQueryStateActions.CHANGE_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case ClaimQueryStateActions.CHANGE_PAGINATION_BIT:
      return {
        ...state,
        pagination: action.payload,
      };

    case ClaimQueryStateActions.CLEAR_STATE:
      return {
        ...claimInitialState,
      };
   
    default:
      return state;
  }
};
